import "antd/es/input/style";
import _Input from "antd/es/input";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import omit from 'omit.js';
import formMethods from '../utils/form-methods';
import { staticFormatMessage as formatMessage } from '../locale';
import './style/index.less';

var IglooInputNumber = function IglooInputNumber(props) {
  var handleOnBlur = function handleOnBlur(e) {
    var value = props.value,
        onChange = props.onChange;

    if (typeof value === 'string') {
      if (value.endsWith('.')) {
        e.target.value = value.replace('.', '');
      }

      if (value.endsWith('0') && value.includes('.')) {
        e.target.value = value.replace(/[0]+$/, '');
      }

      onChange && onChange(e);
    }
  };

  return _jsx(_Input, _objectSpread(_objectSpread({
    className: "igloo-input"
  }, omit(props, formMethods)), {}, {
    onBlur: handleOnBlur,
    type: "number"
  }));
};

IglooInputNumber.formItemPropsHandler = function (config) {
  var length = config.length,
      maxLength = config.maxLength,
      minLength = config.minLength,
      label = config.label,
      pattern = config.pattern;
  var rules = [];

  if (length !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length === length) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {length} digits.',
          values: {
            length: length,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength !== undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length >= minLength && String(value).length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {minLength} - {maxLength} digits.',
          values: {
            maxLength: maxLength,
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength !== undefined && minLength === undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be less than {maxLength} digits.',
          values: {
            maxLength: maxLength,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength === undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || String(value).length >= minLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be at least {minLength} digits.',
          values: {
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }

  if (pattern) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || new RegExp(pattern).test(value)) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must match the pattern {pattern}.',
          values: {
            pattern: pattern,
            label: label
          }
        }));
      }
    });
  }

  return {
    getValueFromEvent: function getValueFromEvent(e) {
      var value = e.target.value;
      var str = value.replaceAll(/[^0-9\.-]/g, '');

      if (str.endsWith('.') || str.includes('.') && str.endsWith('0') || str === '-') {
        return str;
      }

      return str ? parseFloat(str) : undefined;
    },
    rules: rules
  };
};

export default IglooInputNumber;